// src/App.js
import React from 'react';
import { BaseProvider, LightTheme } from 'baseui';
import { Card, StyledBody } from 'baseui/card';
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import { FormControl } from 'baseui/form-control';
import { HeadingLarge, ParagraphSmall } from 'baseui/typography';
import { Block } from 'baseui/block';
import { Notification, KIND } from 'baseui/notification';
import useStore from './store';
import IOSInstallPrompt from './components/IOSInstallPrompt';

function App() {
  const { 
    fromEmail, 
    toEmail, 
    isValidEmail, 
    setFromEmail, 
    setToEmail, 
    generateRandomFrom, 
    getMailtoLink 
  } = useStore();

  const mailtoLink = getMailtoLink(useStore.getState());
  
  console.log('Current mailto link:', mailtoLink);
  console.log('From email:', fromEmail);
  console.log('To email:', toEmail);
  console.log('Is valid email:', isValidEmail);

  return (
    <BaseProvider theme={LightTheme}>
      <Block 
        padding={['8px', '16px', '24px']}
        display="flex" 
        justifyContent="center" 
        alignItems="flex-start"
        minHeight="100%"
        backgroundColor="backgroundPrimary"
        overrides={{
          Block: {
            style: {
              boxSizing: 'border-box',
              paddingTop: ['8px', '16px', '24px'],
              '@media screen and (max-height: 600px)': {
                paddingTop: '4px',
              }
            }
          }
        }}
      >
        <Card 
          overrides={{
            Root: {
              style: {
                width: ['100%', '100%', '450px'],
                maxWidth: '100%',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                marginTop: '0',
                padding: ['12px', '16px', '24px'],
                '@media screen and (max-width: 480px)': {
                  marginTop: '0',
                  padding: '12px'
                }
              }
            }
          }}
        >
          <HeadingLarge marginTop="0" marginBottom={['16px', '20px', '24px']} textAlign="center">
            Haha Mail
          </HeadingLarge>
          
          <StyledBody>
            <FormControl
              label="From (username only)"
              caption="Only enter the username part, without @domain"
              overrides={{
                Label: {
                  style: {
                    fontSize: ['14px', '14px', '16px'],
                    marginBottom: '4px'
                  }
                },
                Caption: {
                  style: {
                    fontSize: ['12px', '12px', '14px'],
                    marginBottom: '8px'
                  }
                }
              }}
            >
              <Block display="flex" alignItems="center">
                <Block flex="1">
                  <Input
                    value={fromEmail}
                    onChange={e => setFromEmail(e.target.value)}
                    placeholder="yourname"
                    overrides={{
                      Input: {
                        style: {
                          fontSize: ['14px', '14px', '16px'],
                          padding: ['8px', '8px', '10px']
                        }
                      }
                    }}
                  />
                </Block>
                <Block marginLeft="16px">
                  <Button 
                    onClick={generateRandomFrom} 
                    kind="secondary"
                    overrides={{
                      BaseButton: {
                        style: {
                          fontSize: ['14px', '14px', '16px'],
                          padding: ['8px', '8px', '10px']
                        }
                      }
                    }}
                  >
                    Random
                  </Button>
                </Block>
              </Block>
            </FormControl>

            <FormControl
              label="To (full email address)"
              caption="Enter a valid email address"
              error={toEmail && !isValidEmail ? "Please enter a valid email address" : null}
              overrides={{
                Label: {
                  style: {
                    fontSize: ['14px', '14px', '16px'],
                    marginBottom: '4px'
                  }
                },
                Caption: {
                  style: {
                    fontSize: ['12px', '12px', '14px'],
                    marginBottom: '8px'
                  }
                }
              }}
            >
              <Input
                value={toEmail}
                onChange={e => setToEmail(e.target.value)}
                placeholder="recipient@example.com"
                error={toEmail && !isValidEmail}
                overrides={{
                  Input: {
                    style: {
                      fontSize: ['14px', '14px', '16px'],
                      padding: ['8px', '8px', '10px']
                    }
                  }
                }}
              />
            </FormControl>

            {fromEmail && toEmail && isValidEmail && (
              <Notification kind={KIND.positive}>
                <ParagraphSmall margin={0} $style={{ fontSize: ['12px', '12px', '14px'] }}>
                  Your email will be sent from: <strong>{fromEmail}@haha.tech</strong> to <strong>{toEmail}</strong>
                </ParagraphSmall>
              </Notification>
            )}

            <Block marginTop="24px">
              <Button
                onClick={() => {
                  if (mailtoLink) {
                    window.location.href = mailtoLink;
                  }
                }}
                disabled={!mailtoLink}
                overrides={{
                  BaseButton: {
                    style: {
                      width: '100%',
                      fontSize: ['16px', '16px', '18px'],
                      padding: ['10px', '12px', '14px']
                    }
                  }
                }}
              >
                Send Email
              </Button>
            </Block>
          </StyledBody>
        </Card>
      </Block>
      <IOSInstallPrompt />
    </BaseProvider>
  );
}

export default App;